/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {BlockElementContainer, BlockElementLabel} from './blockElementContainer';
import {AppColorList, AppTypographyList, BlockElementType} from '../enums';
import {Entity} from 'app/core/main.entity';
import {WorkerShort} from '../workerShort.entity';
import {BlockElement, BlockElementSettings} from './blockElement';
import {BlockElementIcon} from './blockElementIcon';
import {User} from '../user.entity';
import {Blocks} from 'app/entities/blockElements/block.entity';
import {BlockAction} from 'app/entities/blockElements/blockAction';


export class BlockElementWorker extends BlockElement {
  type: BlockElementType = 'worker';

  @Type(() => WorkerShort)
  worker?: WorkerShort = null;

  @Type(() => User)
  user?: User = null;

  @Type(() => BlockAction)
  action?: BlockAction = null; // add to api

  // @Type(() => Entity, {
  //   discriminator: {
  //     property: 'type',
  //     subTypes: [
  //       {value: BlockElementContainer, name: 'basic'},
  //       {value: BlockElementIcon, name: 'icon'}
  //     ],
  //   },
  // })
  @Type(() => BlockElementContainer)
  rightBlock?: BlockElementContainer = null;

  @Type(() => BlockElementWorkerSettings)
  settings?: BlockElementWorkerSettings = new BlockElementWorkerSettings();
}

export class BlockElementWorkerSettings extends BlockElementSettings {
  color?: AppColorList = 'text';
  typography?: AppTypographyList = 'text';
}
